export function getEmailCampaignVariants(campaigns = []) {
  return campaigns.filter(campaign => campaign.type !== 'consentRequest')
}
